<template>
  <div class="videoApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li @click="jump(0,'play')">
        <img src="~assets/images/0.jpg">
        <p>产品视频<i class="el-icon-video-play"></i></p>
      </li>
      <li @click="jump(1,'play')">
        <img src="~assets/images/1.jpg">
        <p>安装视频<i class="el-icon-video-play"></i></p>
      </li>
      <li @click="jump(2,'play')">
        <img src="~assets/images/2.jpg">
        <p>使用说明视频<i class="el-icon-video-play"></i></p>
      </li>
      <li @click="jump(3,'play')">
        <img src="~assets/images/3.jpg">
        <p>创意视频<i class="el-icon-video-play"></i></p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
      };
    },
    beforeMount() {
    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      jump:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .videoApp{
    max-width:640px;
    background:#fff;
    margin:0 auto;
  }

  .videoApp ul{
    width:92%;
    display:block;
    margin:0 auto;
    padding-top:15px;
  }
  .videoApp ul li{
    position:relative;
    margin-bottom:15px;
  }
  .videoApp li img{
    display:block;
    width:100%;
  }
  .videoApp li p{
    font-size:14px;
    font-weight:bold;
    position:absolute;
    left:0;
    bottom:0;
    background:rgba(0,0,0,.5);
    width:97%;
    height:45px;
    color:#fff;
    line-height:45px;
    padding-left:3%;
  }
  .videoApp li p i{
    font-size:22px;
    position:relative;
    top:3px;
    left:5px;
  }
</style>